const ContentTypeModule = {
  namespaced: true,
  state: {
    data: [],
    dialog: false,
    isEditing: false,
    idx: ''
  },
  mutations: {
    UPDATE_DIALOG: (state, payload) => {
      state.dialog = payload 
    },
    IS_EDITING: (state, payload) => {
      state.isEditing = payload 
    },
    SET_IDX: (state, payload) => {
      state.idx = payload 
    },
    FETCH: (state, payload) => {
      state.data = payload
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload)
      state.data.splice(index, 1)
    },
    UPDATE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index] = payload
    },
    INSERT: (state, payload) => {
      state.data.push(payload)
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/farmerspace/content_type/get`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit }, payload) {
      try {
        const response = await axios.delete(`/farmerspace/content_type/delete/${payload}`)
        if (response.data.message === true) {
          iziToast.info({
            title: 'Deleted!',
            position: 'bottomRight'
          })
        }
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async update({ commit, dispatch }, payload) {
      try {
        const response = await axios.put(`/farmerspace/content_type/update`, payload)
        if (response.data.message === true) {
          iziToast.info({
            title: 'Updated!',
            position: 'bottomRight'
          })
        }
        dispatch('fetch')
        commit('UPDATE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(`/farmerspace/content_type/insert`, payload)
        if (response.data.message === true) {
          iziToast.success({
            title: 'Created!',
            position: 'bottomRight'
          })
          dispatch('fetch')
          commit('INSERT', payload)
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    },
    getById: state => payload => {
      return state.data.filter(item => item.idx.match(payload))
    }
  }
}

export default ContentTypeModule



// WEBPACK FOOTER //
// ./src/store/modules/farmerspace/content_type.js